export default {
  language: 'Language',
  contactUs: 'Contact Us',
  officialWebsite: 'Official Website',
  twitter: 'Twitter',
  telegram: 'Telegram',
  connectWallet: 'Connect Wallet',
  connectTPWallet: '1. Connect TokenPocket Wallet',
  addZetaChain: '2. Add ZetaChain Testnet',
  ZETAAmount: '3. Get Testnet $ZETA:',
  start: 'Start',
  verify: 'Verify',
  Verified: 'Verified',
  tutorial: 'Tutorial',
  more: 'More',
  close: 'Close',
  discoverMore: 'Discover More On #TokenPocketChristmas',
  getTestnetZETA: 'Get Testnet $ZETA',
  switchWallet: 'Please switch to the EVM wallet in your wallet first',
  modal: {
    title: 'Connect TokenPocket',
    desc: 'A Gateway to Web3',
    text_1: 'Add TP Extension Wallet to your Chrome',
    text_2: 'Download TokenPocket Mobile Wallet',
    text_3: 'Scan QR code to connect your TokenPocket',
    text_4: 'INJECTED',
  },

  activity_text_1: '1. Verify your social tasks.',
  activity_text_2: 'Finish the social tasks on Galxe.',
  activity_1_1: 'TokenPocket',
  activity_1_2:
    'TokenPocket is the world’s leading multi-chain self-custodial wallet, which supports mainstream public chains including BTC, ETH, BSC, TRON, DOGE, ZetaChain, Polygon, Arbitrum, Optimism, zkSync Era, etc.',

  activity_2_1: 'ZetaSwap',
  activity_2_2:
    'ZetaSwap is the first PMM on ZetaChain powered by Native that lets users swap their assets on the ZetaChain network with ease and efficiency. ZetaSwap ensures you get deep liquidity, cheapest costs, and a user-friendly experience while using ZetaChain.',
  activity_2_5: '2. Trade on ZetaSwap.',
  activity_2_6: 'Swap zetaETH -> zetaBTC or vice-versa.',

  activity_3_1: 'Eddy Finance',
  activity_3_2:
    "Eddy Finance is an Omnichain DEX on ZetaChain that streamlines native asset transfers across networks with unmatched speed and cost-efficiency without any wrapping. Eddy's cross-chain unified liquidity pools combine native assets, including ETH, BTC, BNB, and stablecoins, for optimized efficiency. Eddy further empowers BTC by seamlessly integrating it into the EVM ecosystem, unlocking fresh horizons in DeFi.",
  activity_3_5: '2. Trade on Eddy Finance.',
  activity_3_6: 'Swap any 2 Eddy tokens on the Eddy Finance.',

  activity_4_1: 'LENX',
  activity_4_2:
    'LENX is Bitcoin-focused lending and borrowing protocol. You can deposit and borrow assets to earn the best rates because we leverage time-tested protocols, like Aave and Compound.',
  activity_4_5: '2. Get your Testnet token.',
  activity_4_6: 'You can get the Testnet BTC and ETH from LENX Discord',
  activity_4_7: '3. Borrow or Deposit on LENX.',
  activity_4_8: 'Borrow or deposit any assets on LENX Finance',

  activity_5_1: 'zkMe',
  activity_5_2:
    'zkMe is a decentralized web3 identity oracle that leverages the power of zero-knowledge proofs to enable secure, private, and anonymous credential issuance and verification.',
  activity_5_5: '2. Mint your Omni NFT on zkMe',
  activity_5_6:
    'Draw Christmas Lucky Sign on zkMe webapp page and mint Omni NFT.',

  activity_6_1: 'Ultiverse ',
  activity_6_2:
    "Ultiverse is about making MetaFi a reality and creating a platform for Web3 gaming and Metaverse that offers users many different experiences. They use MetaFi and advanced Dapps to build a community that includes everyone. With over 20 million in funding, Ultiverse's ecosystem is a lively and interactive place that inspires people to be creative and explore.",
  activity_6_5: '2. Mint one Meta Merge Match 3 NFT.',
  activity_6_6: 'Win the first round game and mint your NFT.',

  activity_7_1: 'Sushi',
  activity_7_2:
    'Sushi is a leading multi-chain decentralized exchange (DEX) deployed across 30+ chains and featuring unique cross-chain swaps via SushiXSwap. Focusing on seamless user experiences, innovative trading, and enhanced liquidity provision, Sushi is committed to being a community-built, open-source ecosystem of all the DeFi tools you need.',

  activity_8_1: 'Suger',
  activity_8_2:
    'A Web3 Dating-Fi App that elevates connections beyond  just Romance.',
  activity_8_5: '2. Get a free "Suger Pass".',
  activity_8_6: "Get a free 'Sugar Pass' and join Suger's waitlist.",

  activity_9_1: 'ChatGM',
  activity_9_2:
    "ChatGM uses Interactive AI to make web3 simple and accessible to everyone. With EVM/BTC wallets as digital IDs, ChatGM offers encrypted texting, voice, video calls across crypto wallets, Telegram, WhatsApp. Our edge is the in-app assistant, {'@'}gm.AI, which automatically handles complex crypto tasks for you through chatting.",

  activity_9_5: '2. Visit ChatGM Website and Register a GM Profile.',
  activity_9_6: 'Visit ChatGM and Register a GM Profile (by email or wallet) to win exclusive airdrops and points from ChatGM.',
  activity_9_7: '3. Get 1 POAP of ChatFM OG.',
  activity_9_8: 'Claim the OAT on Galxe, which is the OG POAP of ChatGM.',

  activity_10_1: 'CharacterX',
  activity_10_2:
    'CharacterX is a decentralized synthetic social network where users & AI agents can interact, create, invest & earn. It aims at providing a sustainable economy for creators, consumers, AI agents & investors via innovative AI NFT mechanism. Advanced multi-modal technology including voice, visual and 3D AR significantly adds to the user experience.',
  activity_10_5: '2. Create an AI character and mint NFT.',
  activity_10_6: 'Create your own AI character and mint a Soul Pass NFT',
};
